import { useLocalStorage } from './useLocalStorage'

export type SettingsType = 'list'

export default function useSettings<T>(
  type: SettingsType,
  defaults?: T
): [T, (newValue: T) => void] {
  const [settings, setSettings] = useLocalStorage<T>(
    `@emos/settings/${type}`,
    defaults || ({} as any)
  )

  return [settings, setSettings]
}
